<template>
    <div>
        <CultivationOfTalentsTop />
        <div class="styleSet">
            <div class="title">{{ title }}</div>
            <div class="time">{{ time }}</div>
            <div v-html="info"></div>
        </div>
    </div>
</template>
<script>
import CultivationOfTalentsTop from "@/components/CultivationOfTalentsTop.vue";
export default {
    name: "Detail",
    components: {
        CultivationOfTalentsTop,
    },
    data() {
        return {
            info: "",
            title: "",
            time: "",
        };
    },
    created() {
       if (this.$route.params.title) {
            this.title = this.$route.params.title;
            this.time = this.$route.params.publishTime;
            this.info = this.$route.params.remarks;
            sessionStorage.setItem(
                "params",
                JSON.stringify(this.$route.params)
            );
        } else {
            let params = JSON.parse(sessionStorage.getItem("params"));
            this.title = params.title;
            this.time = params.publishTime;
            this.info = params.remarks;
        }
    },
};
</script>
<style lang="less" scoped>
.styleSet {
    max-width: 1100px;
    margin: 80px auto;
    .title {
        margin-bottom: 20px;
        width: 100%;
        text-align: center;
        font-family: "优设标题黑";
        font-size: 30px;
        color: #333333;
    }
    .time {
        width: 100%;
        text-align: right;
        font-size: 18px;
        color: #333333;
        margin-bottom: 30px;
    }
}
</style>